<template>
  <div>
    <PageAllow controller="StockCurrents" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 仓库中心 -->
              <SearcherStocks
                v-model="stocksSelected"
                :stock-district="stockDistrictSelected"
                :stock-types="[0]"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 历史库存 / 导出 按钮 -->
              <!-- TODO:缺历史库存的接口，有接口之后按钮要加权限判断 -->
              <v-btn
                small
                color="primary"
                class="ms-1"
                v-if="
                  $permission.permissionAllow('StockMaterialHistories', 'index')
                "
                :href="'/#/current-stocks/detail/stock-material-history'"
              >
                <v-icon x-small class="pe-1">fa-history</v-icon>
                {{ $t("CurrentStocks.HistoryStocks") }}
              </v-btn>
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
                v-if="$permission.permissionAllow('StockCurrents', 'export')"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentStocks.Export") }}
              </v-btn>
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="allStockExport()"
                v-if="
                  $permission.permissionAllow('StockCurrents', 'allStockExport')
                "
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentStocks.allStockExport") }}
              </v-btn>

               <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="sheetExport()"
                v-if="
                  $permission.permissionAllow('StockCurrents', 'sheetExport')
                "
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentStocks.allStockExport") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 仓配分组 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStockDistrict v-model="stockDistrictSelected" />
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategoriesWithDescendants
                    v-model="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials
                    v-model="materialSelected"
                    :material-categories="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 商品品牌 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherBrands
                    v-model="brandsSelected"
                  />
                </v-col>
                <!-- 默认供应商 -->
                <v-col cols="12" sm="6" md="4" v-if="settings && settings.show_default_supplier == 1">
                  <SearcherSuppliers
                    ref="supplierSelected"
                    v-model="supplierSelected"
                    :label="$t('Material.Fields.default_supplier')"
                  />
                </v-col>
                <!-- 是否显示零库存商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.zero_status"
                    :items="$consts.currentStocks.zeroStatus"
                    :label="$t('CurrentStocks.zeroStatus.title')"
                  />
                </v-col>
                <!-- 库存状态 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="stocksSelected.length == 1"
                >
                  <SearcherStatus
                    v-model="options.current_count_status"
                    :items="$consts.currentStocks.currentCountStatus"
                    :label="$t('CurrentStocks.currentCountStatus.title')"
                  />
                </v-col>
                <!-- 商品是否启用 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="stocksSelected.length == 1"
                >
                  <SearcherStatus
                    v-model="options.status"
                    :items="$consts.currentStocks.materialsStatus"
                    :label="$t('CurrentStocks.Fields.materialsStatus')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_currents"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td
                  :colspan="
                    settings &&
                    settings.purchase_price_valuation &&
                    settings.purchase_price_valuation == 1
                      ? 7
                      : 5
                  "
                ></td>
                <td v-if="settings && settings.show_default_supplier == 1"></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  {{ stock_currents_total_num | formatTwoDot }}
                </td>
                <td colspan="2"></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  {{ $t("Global.money")
                  }}{{ stock_currents_total_price | formatMoney }}
                </td>
                <td></td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("CurrentStocks.Fields.stock_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ stock_currents_total_num | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("CurrentStocks.Fields.batch_total_num") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ stock_currents_total_price | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <!-- 均价 -->
            <template v-slot:item.average_price="{ item }">
              {{ $t("Global.money") }}
              {{
                item.stock_total == 0
                  ? 0
                  : (item.total_price / item.stock_total) | formatMoney
              }}
            </template>

            <template v-slot:item.category_name="{ item, index }">
              <span
                class="text-no-wrap"
                :v-resize="!index ? $stickTableResizer() : null"
              >
                {{ item.category_name }}
              </span>
            </template>
            <template v-slot:item.material_name="{ item }">
              <span class="text-no-wrap">
                <span>
                  {{ item.material_name }}
                </span>
                <br />
                <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
              </span>
            </template>
            <template v-slot:item.default_supply_price="{ item }">
              {{ $t("Global.money")
              }}{{ item.default_supply_price | formatMoney }}
            </template>
            <template v-slot:item.supply_total_price="{ item }">
              {{ $t("Global.money")
              }}{{ item.supply_total_price | formatMoney }}
            </template>
            <!-- 格式化数字 -->
            <template v-slot:item.stock_unit_num="{ item }">
              <span v-if="!locale">
                {{ item.stock_unit_num }}
              </span>
              <span v-else>
                {{ item.stock_single_unit_num }}
                <br />
                <span class="pt-n1 text-no-wrap caption">
                  {{ item.stock_unit }}
                </span>
              </span>
            </template>
            <template v-slot:item.stock_total="{ item }">
              <span v-if="!locale" class="text-no-wrap">
                {{ $numberFormatter.formatTwoDot(item.stock_total, true)
                }}{{ item.default_unit }}
              </span>
              <span v-else>
                {{ $numberFormatter.formatTwoDot(item.stock_total, true) }}
                <br />
                <span class="pt-n1 text-no-wrap caption">
                  {{ item.default_unit }}
                </span>
              </span>
            </template>
            <template v-slot:item.stock_no_occupy_num="{ item }">
              <span v-if="!locale" class="text-no-wrap">
                {{ item.stock_no_occupy_num }}
              </span>
              <span v-else>
                {{
                  $numberFormatter.formatTwoDot(
                    item.stock_single_no_occupy_num,
                    true
                  )
                }}
                <br />
                <span class="pt-n1 text-no-wrap caption">
                  {{ item.stock_unit }}
                </span>
              </span>
            </template>
            <template v-slot:item.stock_occupy_num="{ item }">
              <span v-if="!locale" class="text-no-wrap">
                {{ item.stock_occupy_num }}
              </span>
              <span v-else>
                {{
                  $numberFormatter.formatTwoDot(
                    item.stock_single_occupy_num,
                    true
                  )
                }}
                <br />
                <span class="pt-n1 text-no-wrap caption">
                  {{ item.stock_unit }}
                </span>
              </span>
            </template>
            <!-- 待上架数量格式化 -->
            <template v-slot:item.wait_shelve_num="{ item }">
              <span v-if="item.wait_shelve_num">
                {{
                  item.wait_shelve_num
                    ? $numberFormatter.formatTwoDot(item.wait_shelve_num) +
                      item.unit
                    : ""
                }}
              </span>
            </template>
            <!-- 批次数量格式化 -->
            <template v-slot:item.batch_total_num="{ item }">
              <span v-if="item.batch_total_num">
                {{
                  item.batch_total_num
                    ? $numberFormatter.formatTwoDot(item.batch_total_num) +
                      item.unit
                    : ""
                }}
              </span>
            </template>
            <!-- 格式化金额 -->
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
            </template>
            <template v-slot:item.batch_total_price="{ item }">
              {{ $t("Global.money") }}{{ item.batch_total_price | formatMoney }}
            </template>
            <!-- 状态 -->
            <template v-slot:item.currentStocks_status="{ item }">
              <span
                v-if="
                  item.shortage == 0 &&
                  item.over_load == 0 &&
                  item.expire_status == 0
                "
              >
                <v-chip
                  small
                  label
                  :color="item.currentStocks_status ? 'primary' : 'primary'"
                  text-color="white"
                >
                  {{ $t("CurrentStocks.status.on") }}
                </v-chip>
              </span>
              <span v-if="item.shortage == 1">
                <v-chip
                  small
                  label
                  :color="item.status_flg ? 'danger' : 'danger'"
                  text-color="white"
                  style="margin-top: 5px"
                >
                  {{ $t("CurrentStocksDetails.status.off_min") }}
                </v-chip>
              </span>
              <span v-if="item.over_load == 1">
                <v-chip
                  small
                  label
                  :color="item.status_flg ? 'danger' : 'danger'"
                  text-color="white"
                  style="margin-top: 5px"
                >
                  {{ $t("CurrentStocksDetails.status.off_max") }}
                </v-chip>
              </span>
              <span v-if="item.expire_status == 1">
                <v-chip
                  small
                  label
                  :color="item.status_flg ? 'warning' : 'warning'"
                  text-color="white"
                  style="margin-top: 5px"
                >
                  {{ $t("CurrentStocksDetails.status.off") }}
                </v-chip>
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu
                v-model="item.printBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    dark
                    color="info"
                    class="px-2"
                    @click.stop=""
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("CurrentStocks.actions.details") }}
                    <v-icon x-small class="ps-1">
                      {{ item.printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="$permission.permissionAllow('StockCurrents', 'view')"
                    :href="'/#/current-stocks/' + item.material_id"
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.stock_details") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="$permission.permissionAllow('StockDetails', 'index')"
                    :href="
                      '/#/stock-details?material_id=' +
                      item.material_id +
                      '&' +
                      (options.district_ids && options.district_ids.length > 0
                        ? 'stock_district_id=' + options.district_ids[0]
                        : '') +
                      '&' +
                      (options.stock_ids && options.stock_ids.length > 0
                        ? 'stock_id=' + options.stock_ids[0]
                        : '')
                    "
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.batch_details") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 出入库明细 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow('StockOrderAnalyze', 'view')
                    "
                    :href="
                      '/#/stock-order-analyze/' +
                      item.material_id +
                      '?' +
                      (options.district_ids && options.district_ids.length > 0
                        ? 'stock_district_id=' + options.district_ids[0]
                        : '') +
                      '&' +
                      (options.stock_ids && options.stock_ids.length > 0
                        ? 'stock_id=' + options.stock_ids[0]
                        : '')
                    "
                  >
                    <v-list-item-title>
                      {{ $t("CurrentStocks.actions.in_out_details") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import StockCurrents from "@/api/current_stocks";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherStockDistrict from "@/components/plugins/SearcherStockDistrict";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherBrands from "@/components/plugins/SearcherBrands";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers";

const defaultOptions = {
  status: [0, 1],
  district_ids: [],
  material_category_codes: [],
  material_ids: [],
  zero_status: [],
  current_count_status: [],
  brands: [],
  supplier_ids: [],
};

export default {
  data: () => ({
    stock_currents: [],
    stocksSelected: [],
    materialCategoriesSelected: [],
    materialSelected: [],
    stockDistrictSelected: null,
    supplierSelected: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("stock_currents-options")
        ? sessionStorage.getItem("stock_currents-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    stock_currents_total_num: 0,
    stock_currents_batch_total_num: 0,
    stock_currents_total_price: 0,
    stock_currents_batch_total_price: 0,
    brandsSelected: [],
    // result:null
  }),
  components: {
    Breadcrumbs,
    SearcherStocks,
    PageAllow,
    SearcherStatus,
    SearcherMaterialCategoriesWithDescendants,
    SearcherStockDistrict,
    SearcherMaterials,
    SearcherBrands,
    SearcherSuppliers,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    locale() {
      return this.$i18n.locale != "zhHans";
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.currentStocks"),
        disabled: true,
        href: "/current-stocks",
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("CurrentStocks.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("CurrentStocks.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("CurrentStocks.Fields.material_category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
      ];
      if (
        this.settings &&
        this.settings.purchase_price_valuation &&
        this.settings.purchase_price_valuation == 1
      ) {
        headers.push(
          {
            text: i18n.t("CurrentStocks.Fields.default_purchases_price"),
            align: "end",
            sortable: false,
            value: "default_supply_price",
          },
          {
            text: i18n.t("CurrentStocks.Fields.purchase_sum_price"),
            align: "end",
            sortable: false,
            value: "supply_total_price",
          }
        );
      }
      headers.push(
        {
          text: i18n.t("CurrentStocks.Fields.average"),
          align: "end",
          sortable: false,
          value: "average_price",
        },
        // 状态
        {
          text: i18n.t("CurrentStocks.Fields.status"),
          align: "start",
          sortable: false,
          value: "currentStocks_status",
        }
      );
      if (this.settings && this.settings.show_default_supplier == 1) {
        headers.push(
          {
            text: i18n.t("CurrentStocks.Fields.default_supplier"),
            align: "start",
            sortable: false,
            value: "supplier_name",
          }
        )
      }
      headers.push(
        {
          text: i18n.t("CurrentStocks.Fields.stock_total"),
          align: "end",
          sortable: false,
          value: "stock_unit_num",
        },
        {
          text: i18n.t("CurrentStocks.Fields.default_total"),
          align: "end",
          sortable: false,
          value: "stock_total",
        },
        {
          text: i18n.t("CurrentStocks.Fields.usable_stock_num"),
          align: "end",
          sortable: false,
          value: "stock_no_occupy_num",
        },
        {
          text: i18n.t("CurrentStocks.Fields.occupy_stock_num"),
          align: "end",
          sortable: false,
          value: "stock_occupy_num",
        },
        // 商品总金额
        {
          text: i18n.t("CurrentStocks.Fields.total_price"),
          align: "end",
          sortable: false,
          value: "total_price",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      )
      return headers;
    },
    ...mapState(["settings", "stickTableCols"]),
  },

  mounted() {
    if (this.$route.query.stock_id && this.$route.query.material_id) {
      this.stocksSelected = [{ id: Number(this.$route.query.stock_id) }];
      this.materialSelected = [{ id: Number(this.$route.query.material_id) }];
      this.onSearch();
    } else {
      this.$commonUtils
        .loadOptions("stock_currents", [
          "stocksSelected",
          "stockDistrictSelected",
          "materialCategoriesSelected",
          "materialSelected",
          "brandsSelected",
          "supplierSelected",
        ])
        .then(
          function (data) {
            if (data.options) {
              this.options = data.options;
            } else this.resetSearch();
            data.selecteds.forEach((selected) => {
              switch (selected.key) {
                case "stocksSelected":
                  this.stocksSelected = selected.value;
                  break;
                case "stockDistrictSelected":
                  this.stockDistrictSelected = selected.value;
                  break;
                case "materialCategoriesSelected":
                  this.materialCategoriesSelected = selected.value;
                  break;
                case "materialSelected":
                  this.materialSelected = selected.value;
                  break;
                case "brandsSelected":
                  this.brandsSelected = selected.value;
                  break;
                case "supplierSelected":
                  this.supplierSelected = selected.value;
                  break;
              }
            });
          }.bind(this)
        );
    }
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.stocksSelected = [];
      this.stockDistrictSelected = null;
      this.supplierSelected = [];
      this.materialCategoriesSelected = [];
      this.materialSelected = [];
      this.brandsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getCurrentStocksFromAPI() {
      this.loading = true;
      this.id = this.$route.query.stock_id;
      StockCurrents.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_currents = response.data.stock_currents.map(
              (stock_current) => {
                stock_current.default_supply_price =
                  this.$numberFormatter.formatTwoDot(
                    stock_current.supply_price / stock_current.supply_unit_rate
                  );

                return stock_current;
              }
            );
            this.stock_currents_total_num =
              response.data.stock_currents_total_num;
            this.stock_currents_batch_total_num =
              response.data.stock_currents_batch_total_num;
            this.stock_currents_total_price =
              response.data.stock_currents_total_price;
            this.stock_currents_batch_total_price =
              response.data.stock_currents_batch_total_price;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      StockCurrents.exports(this.options);
    },
    allStockExport() {
      StockCurrents.allStockExport(this.options);
    },
    sheetExport(){
      StockCurrents.sheetExport(this.options);
    }
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getCurrentStocksFromAPI();
        sessionStorage.setItem(
          "stock_currents-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 仓配中心搜索
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stock_currents-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
        if (this.stocksSelected.length != 1) {
          this.options.current_count_status = [];
          this.options.status = [0, 1];
        }
      },
    },
    // 仓库组别
    stockDistrictSelected: {
      handler() {
        this.options.district_ids = this.stockDistrictSelected
          ? [this.stockDistrictSelected.id]
          : [];
        sessionStorage.setItem(
          "stock_currents-stockDistrictSelected",
          JSON.stringify(this.stockDistrictSelected)
        );
      },
    },
    supplierSelected: {
      handler() {
        this.options.supplier_ids = this.supplierSelected
            ? this.supplierSelected.map((supplier) => {
              return supplier.id;
            })
            : "";
        sessionStorage.setItem(
            "stock_currents-supplierSelected",
            JSON.stringify(this.stockDistrictSelected)
        );
      }
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.material_category_codes = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.code;
            })
          : "";
        sessionStorage.setItem(
          "stock_currents-materialCategoriesSelected",
          JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },

    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stock_currents-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    // 商品品牌
    brandsSelected: {
      handler() {
        this.options.brands = this.brandsSelected
          ? this.brandsSelected.map((e) => {
            return e
          })
          : "";
        sessionStorage.setItem(
          "stock_currents-brandsSelected",
          JSON.stringify(this.brandsSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>